import { render, staticRenderFns } from "./ProductConfig.vue?vue&type=template&id=42c98f9a&scoped=true&"
import script from "./ProductConfig.vue?vue&type=script&lang=js&"
export * from "./ProductConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c98f9a",
  null
  
)

export default component.exports